import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { Alert } from "components/common";
import TableView from "./table/TableView";

export default function HoldingTankPage() {
  const myUser = useSelector((state) => state.auth.user);
  const [isPlacable, setIsPlacable] = useState(false);

  const checkPlacable = () => {
    let isPlacable = false;
    if (myUser.id == 1) {
      isPlacable = true;
    } else if (myUser.parent_id) {
      isPlacable = true;
    }
    setIsPlacable(isPlacable);
  };
  useEffect(() => {
    checkPlacable();
  }, []);

  return (
    <Wrapper>
      <Alert
        type={"info"}
        showIcon
        message={
          "Your Holding Tank is where your personally enrolled Social Marketers will appear so you can assign a location in your downline. To place your Social Marketers, simply enter the ID# of the person they go under, and click “place”."
        }
      />
      <div style={{ height: 12 }} />
      <TableView />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-bottom: 80px;
  .submitButton {
    background: #0ABAB5;
    border: 1px solid rgba(145, 158, 171, 0.32);
    border-radius: 8px !important;
    box-shadow: none !important;
    border: none;
  }
  .table-new-wrapper {
    .ant-table-cell {
      .content-root {
        .title {
          font-weight: 600;
        }
        .join-date {
          color: #637381;
        }
      }
    }
  }
  .panelHead {
    padding-top: 24px;
    padding-bottom: 12px;
  }
`;
